import Swiper, { Navigation } from "swiper";

export default class ComponentVideo {
    constructor() {

        this.slider = document.querySelector(".swiper--component-video")
        this.navigationPrev = document.querySelector(".slider-button-prev--component-video")
        this.navigationNext = document.querySelector(".slider-button-next--component-video")

        this.btnOpenVideo = this.slider.querySelectorAll('[data-video]')
        this.modalVideo = document.querySelector('.modal-video')
        this.videoLocal = this.modalVideo.querySelector('#video-container')
        this.btnCloseModalVideo = this.modalVideo.querySelector('.closeModal')

        this.ready();
    }

    ready() {

        const swiper = new Swiper(this.slider, {
            modules: [Navigation],
            grabCursor: true,
            spaceBetween: 0,
            slidesPerView: 1,
            allowTouchMove: true,
            navigation: {
                nextEl: this.navigationNext,
                prevEl: this.navigationPrev
            }
        })

        this.btnOpenVideo.forEach(el => {
            el.addEventListener('click', () => {
                const video = el.getAttribute('data-video')
                console.log(video);

                let iframe = document.createElement( "iframe" );

                iframe.setAttribute("frameborder", "0");
                iframe.setAttribute("allowfullscreen", "");
                iframe.setAttribute("allow", "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture");
                // Important: add the autoplay GET parameter, otherwise the user would need to click over the YouTube video again to play it 
                iframe.setAttribute("src", video);

                // Clear Thumbnail and load the YouTube iframe
                this.videoLocal.innerHTML = "";
                this.videoLocal.appendChild( iframe );

                this.modalVideo.classList.add('active')
                this.btnCloseModalVideo.addEventListener('click', () => {
                    this.modalVideo.classList.remove('active')
                    this.videoLocal.innerHTML = "";
                })
            })
        })

    }
}